import { Injectable, Inject } from '@angular/core';
import { DOCUMENT } from "@angular/common";

@Injectable({
  providedIn: 'root'
})
export class FaviconService {

  constructor(
    @Inject(DOCUMENT)
    private document: HTMLDocument
  ) { }

  lvi(){
    this.document.getElementById("appFavicon")!.setAttribute("href", "assets/favicon-lvi.ico");
  }

  sbms(){
    this.document.getElementById("appFavicon")!.setAttribute("href", "assets/favicon-lvconnect.ico");
  }
}
